import CommonClasses from "./common.module.css";
import { MdOutlineMail } from "react-icons/md";
import { TbPhone } from "react-icons/tb";
import { IoMdTime } from "react-icons/io";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";

import SideNav from "./Sidenav/Index";
import Footer from "./Footer/Footer";
interface Layout {
    children: React.ReactNode;
}

const Common: React.FC<Layout> = ({ children }) => {
    return (
        <div className={CommonClasses["Container"]}>
            <div className={CommonClasses["ScrollingMessage"]}></div>
            <div className={CommonClasses["about"]}>
                <p>
                    <MdOutlineMail size={16} />
                    info@serenetax.com - contact@serenetax.com
                </p>
                <span></span>
                <p>
                    <TbPhone size={16} />
                    (+262-735-8874) - (+262-735-8875)
                </p>
                <span></span>
                <p>
                    <IoMdTime size={16} />
                    Mon - Fri 7:30 am - 11:30pm
                </p>
                <span></span>
                <div className={CommonClasses["Icons"]}>
                    <FaInstagram />
                    <FaTwitter />
                    <FaLinkedin />
                </div>
            </div>
            <SideNav />
            {children}
            <Footer />
        </div>
    );
};

export default Common;
